import React, { createContext, useState } from 'react';
import { cn } from '../cn';

export type AccordionStateContextValue = {
  currentActiveId: string | null,
  setCurrentActiveId: (id: string | null) => void,
  showOne: boolean,
};
export const AccordionStateContext = createContext<AccordionStateContextValue>({
  currentActiveId: null,
  setCurrentActiveId: (id: string | null): void => undefined,
  showOne: false,
});

export type AccordionProps = React.PropsWithChildren<{
  className?: string,
  showOne?: boolean,
  defaultActiveId?: string,
  id?: string,
}>;

export const Accordion = (props: AccordionProps): JSX.Element => {
  const [currentActiveId, setCurrentActiveId] = useState<string | null>(null);

  return (
    <div id={props.id} className={cn(
      'flex flex-col gap-8',
      props.className
    )}>
      <AccordionStateContext.Provider value = {{ currentActiveId, setCurrentActiveId, showOne: props.showOne === true }}>
        {props.children}
      </AccordionStateContext.Provider>
    </div>
  );
};
